/**
 * Форматтер лога боя
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Извлекает флаги из записи боя
 * @param {object} entry - Запись из лога боя
 * @returns {array} Массив строк с описанием флагов
 */
export function extractBattleFlags(entry) {
  if (!entry) return [];
  
  const flags = [];
  
  // Обработка причин блокировки
  if (entry.reason === "floating_god_cloud") {
    flags.push("NaN туман рассеял удар");
  } else if (entry.reason === "invalid_god_structure") {
    flags.push("структурная атака рассыпалась");
  }
  
  // Обработка искажения типов
  const abilityFlags = entry.flags?.ability;
  if (abilityFlags?.hexGodCorruption?.forcedTypes?.length) {
    flags.push(
      `тип атаки искажён → ${abilityFlags.hexGodCorruption.forcedTypes.join("/")}`
    );
  }
  
  // Обработка преобразования урона в NaN
  const damageFlags = entry.flags?.damage;
  if (damageFlags?.nanNullified) {
    flags.push("урон преобразован в NaN");
  }
  
  return flags;
}

/**
 * Форматирует запись лога боя в читаемую строку
 * @param {object} entry - Запись из лога боя
 * @param {function} getCombatantName - Функция для получения имени бойца по ID
 * @returns {string} Отформатированная строка
 */
export function formatBattleLogEntry(entry, getCombatantName = () => null) {
  if (!entry) return "";
  
  const roundPrefix = entry.round != null ? `Раунд ${entry.round}: ` : "";
  const source = entry.source != null 
    ? (getCombatantName(entry.source) || `Боец #${entry.source}`) 
    : null;
  const target = entry.target != null 
    ? (getCombatantName(entry.target) || `Боец #${entry.target}`) 
    : null;
  const damage = entry.value != null ? ` (−${Math.round(entry.value)})` : "";
  const flags = extractBattleFlags(entry);
  const flagsText = flags.length ? ` • ${flags.join("; ")}` : "";
  
  switch (entry.event) {
    case "attack":
      return `${roundPrefix}⚔️ ${source || entry.source} → ${target || entry.target}${damage}${flagsText}`;
    
    case "attack_blocked":
      return `${roundPrefix}🛡️ ${source || entry.source} не смог пробить ${target || entry.target}${flagsText || " • защита удержала удар"}`;
    
    case "stack_reset":
      return `${roundPrefix}🔄 Перезагрузка The Stack`;
    
    case "skip":
      return `${roundPrefix}⏭️ ${source || entry.source} пропускает ход`;
    
    case "evolution":
      return `${roundPrefix}✨ Эволюция!`;
    
    default:
      return `${roundPrefix}${entry.event || "событие"}`;
  }
}











